import { AppRouteProps } from '@bsm/component'
import React from 'react'
import { StudentsContainer } from './container/StudentsContainer'
import { StudentListRoutes } from 'views/list/StudentListRoutes'
import { StudentDetailsRoutes } from 'views/details/StudentDetailsRoutes'

export const StudentsRoutes: Array<AppRouteProps> = [
    {
        path: "",
        element: <StudentsContainer />,
        children: [
            ...StudentListRoutes,
            ...StudentDetailsRoutes
        ]
    }
]
